export const RetailTransactionsRouteParts = {
    exportFromGlobalSearch: 'search/export',
    exportFromProduct: 'details/transactions/pages/export',
    searchInProduct: 'transactions/search',
};
